import { ApiBase } from '@/api/methods/ApiBase'
import {
  ApiResponseGeneralLearning,
  ApiResponseGeneralLearningProgresses,
  ApiResponseGeneralProblemHistories,
  ApiResponseCountUserGeneralLearning,
} from '@/api/responses/generalLearnings'

export namespace GeneralLearningsApi {
  /**
   * 演習履歴取得(通常授業サポート学習)
   *
   * @param learningId 履歴ID
   * @returns 演習履歴
   */
  export async function getGeneralLearning(learningId: number): Promise<ApiResponseGeneralLearning> {
    return await ApiBase.get(`/generalLearnings/${learningId}`)
  }

  /**
   * 単元別進捗履歴一覧取得API
   *
   * @param userId ユーザID
   * @param curriculumUnitId 単元ID
   * @returns 進捗履歴一覧
   */
  export async function getPassage(
    userId: number,
    curriculumUnitId: number
  ): Promise<ApiResponseGeneralLearningProgresses> {
    const params = {
      userId: userId,
      curriculumUnitId: curriculumUnitId,
    }
    return await ApiBase.get(`generalLearnings/passage`, params)
  }

  /**
   * 単元別問題演習履歴一覧取得API
   *
   * @param learningId 演習履歴ID
   * @returns 問題演習履歴一覧
   */
  export async function getProblemHistory(learningId: number): Promise<ApiResponseGeneralProblemHistories> {
    return await ApiBase.get(`generalLearnings/${learningId}/problem`)
  }

  /**
   * 通算演習回数取得API(通常授業サポート学習)
   *
   * @returns ユーザ別通算演習回数
   */
  export async function getCount(): Promise<ApiResponseCountUserGeneralLearning> {
    return await ApiBase.get(`generalLearnings/count`)
  }
}
